var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "layout",
      attrs: {
        page: "/myschedule",
        pageTitle: "Lessons",
        tabs: true,
        filterData: _vm.filterData,
        showBanner: _vm.showBanner,
      },
      on: { filterResults: _vm.returnFilterResults },
      scopedSlots: _vm._u([
        {
          key: "tabs",
          fn: function () {
            return [
              _c(
                "v-tabs",
                {
                  attrs: { "background-color": "transparent" },
                  model: {
                    value: _vm.selectedTab,
                    callback: function ($$v) {
                      _vm.selectedTab = $$v
                    },
                    expression: "selectedTab",
                  },
                },
                [
                  _c(
                    "v-tab",
                    {
                      staticClass: "no-link",
                      attrs: { href: "/myschedule/upcoming" },
                    },
                    [
                      _c(
                        "Link",
                        {
                          staticClass:
                            "no-link flex align-center justify-center min-h-full",
                          attrs: {
                            href: "/myschedule/upcoming",
                            "preserve-state": "",
                            only: ["lessons", "loadMore"],
                          },
                        },
                        [_vm._v("Upcoming")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab",
                    {
                      staticClass: "no-link",
                      attrs: { href: "/myschedule/past" },
                    },
                    [
                      _c(
                        "Link",
                        {
                          staticClass:
                            "no-link flex align-center justify-center min-h-full",
                          attrs: {
                            href: "/myschedule/past",
                            "preserve-state": "",
                            only: ["pastLessons", "loadMore"],
                          },
                        },
                        [_vm._v("Past")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-container",
        { class: _vm.$vuetify.breakpoint.xs ? "px-0" : null },
        [
          _c("StudentBookingPanel", {
            attrs: {
              user: _vm.auth.user,
              sharedSubscriptions: _vm.sharedSubscriptions,
              hasFutureLessons: _vm.hasFutureLessons,
              hasPastLessons: _vm.hasPastLessons,
              hasCancelledLessons: _vm.hasCancelledLessons,
              activeMemberships: _vm.activeMemberships,
              disabled: _vm.disabled,
              apiLoading:
                _vm.apiLoading && _vm.$refs.createLesson?.stepNumber <= 1,
            },
            on: {
              bookNow: function ($event) {
                return _vm.handleBookNow($event)
              },
              contactStudio: function ($event) {
                _vm.contactStudio = true
              },
            },
          }),
          _vm._v(" "),
          _vm.contactStudio
            ? _c("SoliResponsiveDialog", {
                ref: "locationContact",
                attrs: { title: "Contact Us!" },
                on: {
                  reset: function ($event) {
                    _vm.closeModal(() => (_vm.contactStudio = false))
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("SoliLocations", {
                            attrs: {
                              parentLocations:
                                _vm.$page.props.auth.user.locations,
                              value:
                                _vm.$page.props.auth.user.selected_location,
                              iterator: "",
                              showAddress: "",
                              hideDetails: "",
                              expandable: "",
                              hideSearch: "",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2087226088
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$vuetify.breakpoint.xs ? "px-1" : null },
            [
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.selectedTab,
                    callback: function ($$v) {
                      _vm.selectedTab = $$v
                    },
                    expression: "selectedTab",
                  },
                },
                [
                  _c(
                    "v-tab-item",
                    { attrs: { value: "/myschedule/upcoming" } },
                    [
                      _c("LessonPanels", {
                        staticClass: "animate__animated animate__fadeIn",
                        attrs: {
                          disabled: _vm.disabled,
                          lessons: _vm.getLessons,
                          activeMemberships: _vm.activeMemberships,
                          relationships: _vm.relationships,
                          loadMore: _vm.loadMore,
                        },
                        on: {
                          reschedule: function ($event) {
                            return _vm.handleBookMySchedule($event)
                          },
                          cancel: function ($event) {
                            _vm.confirmCancelAlert = $event
                          },
                          move: function ($event) {
                            _vm.confirmMove = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    { attrs: { value: "/myschedule/past" } },
                    [
                      _c("LessonPanels", {
                        staticClass: "animate__animated animate__fadeIn",
                        attrs: {
                          disabled: _vm.disabled,
                          lessons: _vm.getPastLessons,
                          isPast: "",
                          activeMemberships: _vm.activeMemberships,
                          relationships: _vm.relationships,
                          loadMore: _vm.loadMore,
                        },
                        on: {
                          cancel: function ($event) {
                            _vm.confirmCancelAlert = $event
                          },
                          reschedule: function ($event) {
                            return _vm.handleBookMySchedule($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.loading
            ? _c("v-skeleton-loader", {
                staticClass: "mx-4",
                attrs: {
                  type: "list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.confirmCancelAlert
        ? _c("SoliChoice", {
            attrs: {
              title: "Heads up!",
              subtitle: _vm.confirmCancelAlert.warning,
              button1: "Confirm",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                return _vm.confirmCancel(_vm.confirmCancelAlert)
              },
              reset: function ($event) {
                _vm.confirmCancelAlert = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmMove
        ? _c("SoliChoice", {
            attrs: {
              title: "Are you sure?",
              subtitle: `Your lesson on ${_vm.globalMomentDateShort(
                new Date(_vm.confirmMove.starts_at)
              )} will be moved ${
                _vm.confirmMove.online ? `In-person` : "Online"
              } and your teacher will be notified.`,
              button1: "Confirm",
              loading1: "",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                return _vm.moveOnline(_vm.confirmMove)
              },
              reset: function ($event) {
                _vm.confirmMove = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showMessage
        ? _c("SoliSnack", {
            attrs: { text: _vm.$page.props.successMessage },
            on: {
              hide: function ($event) {
                _vm.showMessage = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clickData
        ? _c("CreateLesson", {
            ref: "createLesson",
            attrs: {
              errors: _vm.errors,
              event: _vm.clickData,
              bookingSource: _vm.bookingSource,
              relationships: _vm.relationships,
            },
            on: {
              apiLoading: function ($event) {
                _vm.apiLoading = $event
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.clickData = null))
              },
              success: _vm.handleSuccess,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loadContract
        ? _c("Contracts", {
            key: _vm.loadContract.id,
            attrs: {
              contracts: _vm.loadContract.unsignedContract,
              client: _vm.auth.user,
              purchaseOption: _vm.loadContract,
            },
            on: {
              success: function ($event) {
                return _vm.handleContractSuccess()
              },
              reset: function ($event) {
                return _vm.handleContractReset()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showContract
        ? _c("SoliChoice", {
            attrs: {
              permanent: "",
              title: "Heads up",
              subtitle:
                "You have recently purchased a pass or membership with Musicologie. Please agree to the terms to continue",
              button1: "View Agreement",
            },
            on: {
              option1: function ($event) {
                _vm.loadContract = _vm.unsignedContracts[0]
              },
              reset: function ($event) {
                _vm.showContract = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.viewNotes
        ? _c("SoliForm", {
            attrs: {
              title: `Lesson Notes for ${_vm.globalMomentDateShort(
                _vm.viewNotes.date
              )}`,
              saveChanges: false,
              hideBtn: "",
            },
            on: {
              reset: function ($event) {
                _vm.viewNotes = null
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("v-textarea", {
                        ref: "notes",
                        staticClass: "soli-round",
                        attrs: {
                          outlined: "",
                          dense: "",
                          label: `What we worked on during this lesson:`,
                          value: _vm.viewNotes.lessonNote,
                          readonly: "",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-textarea", {
                        staticClass: "soli-round",
                        attrs: {
                          outlined: "",
                          dense: "",
                          label: `What ${
                            _vm.viewNotes.student.id ==
                            _vm.$page.props.auth.user.id
                              ? "you"
                              : _vm.viewNotes.student.first_name
                          } should work on at home:`,
                          value: _vm.viewNotes.practiceNote,
                          readonly: "",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3437240561
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }